const context = {};
context.imageServer='https://gstptravel.oss-cn-zhangjiakou.aliyuncs.com/static/images/';
context.baseUrl ='';
{
    if(location.hostname==='m.changkun.top'){
        context.baseUrl ='https://m.changkun.top/api';
    }else{
        context.baseUrl ='https://admin.changkun.top/api' ;
    }
}
context.pageUrl = 'https://m.changkun.top/index.html';
context.wxGetConfigUrl='https://admin.changkun.top/redirect/wxfe42689b9e435f72/signature?url=https://gstpadmin.huntauto.com.cn/travel/demo.html';
context.wxGetPosition = 'http://admin.changkun.top/redirect/wxfe42689b9e435f72/signature?url=http://gstpapi.huntauto.com.cn/travel/demo.html';
export default context;
